<div class="mt-8 max-w-7xl">

    <div class="w-full flex flex-col gap-4 mb-4">
        <app-btn-back routeTo=".." icon="fa fa-close" btnText="Cancel"></app-btn-back>
        <h1 class="font-semibold text-2xl capitalize text-primary-500 mb-0">New Prayer</h1>
    </div>

    <div class="flex flex-col w-full">
        <form [formGroup]="pageForm" (ngSubmit)="create()">

            @let group = group$ | async;

            @if (group) {
            <div class="flex flex-col w-full">

                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Subject *
                    </label>
                    <input type="text" type="subject" formControlName="subject" id="subject" name="subject" required
                        minlength="5" maxlength="100"
                        class="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                    <div
                        class="{{pageForm.get('subject')?.invalid && (pageForm.get('subject')?.dirty || pageForm.get('subject')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('subject')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="pageForm.get('subject')?.errors?.['minlength'] || pageForm.get('subject')?.errors?.['maxlength']">
                            Min 5 and max 100 characters required
                        </p>
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required minlength="10" maxlength="500"
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        rows="4">
                    </textarea>
                    <div
                        class="{{ pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                        <p *ngIf="pageForm.get('description')?.errors?.['required']">
                            Value is required
                        </p>
                        <p
                            *ngIf="pageForm.get('description')?.errors?.['minlength'] || pageForm.get('description')?.errors?.['maxlength']">
                            Min 10 and max 500 characters required
                        </p>
                    </div>
                </div>

                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Category *
                    </label>
                    <div class="flex flex-wrap gap-1">
                        @for (item of group.prayerCategories; track $index) {
                        <button type="button" (click)="setCategory(item)" data-dismissible="chip"
                            class="relative flex select-none items-center whitespace-nowrap rounded-lg {{ item == pageForm.get('category')?.value ? 'bg-primary-500 text-white' : 'bg-gray-200 text-primary-500' }} focus:outline-none h-7 max-h-7 px-2 text-xs font-normal">
                            <span class="grow-0">{{item}}<i
                                    class="{{item != pageForm.get('category')?.value ? 'hidden' : 'visible'}} fa fa-check ml-2 text-white leading-relaxed"></i></span>
                        </button>
                        }
                    </div>
                    <div
                        class="{{ pageForm.get('category')?.invalid && (pageForm.get('category')?.dirty || pageForm.get('category')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                        <div *ngIf="pageForm.get('category')?.errors?.['required']">
                            Value is required
                        </div>
                    </div>
                </div>

                <div class="relative w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Requested By *
                    </label>
                    <div class="relative">
                        <div class="flex flex-row">
                            <input type="text" autocomplete="off" (change)="search($event)"
                                [value]="pageForm.get('requestedBy')?.value"
                                placeholder="Search and Select prayer requester's name"
                                class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-l text-sm shadow focus:outline-none grow py-2 px-3 ease-linear transition-all duration-150" />
                            <button type="button" (click)="searchMembers()" [disabled]="isSearching"
                                class="bg-primary-500 text-white text-sm px-4 py-2 shadow border-0 focus:outline-none whitespace-nowrap w-fit rounded-r">
                                <i *ngIf="!isSearching" class="fa fa-search mr-2"></i>
                                <svg *ngIf="isSearching" class="animate-spin -ml-1 mr-2 h-5 w-5 text-white inline"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                                Search
                            </button>
                        </div>
                        <div class="absolute left-0 top-0 w-full px-3 pt-3 bg-blueGray-100 z-20 overflow-hidden rounded-b shadow-lg border-1 border-primary-500"
                            [hidden]="members?.length == 0">
                            @for (member of members; track $index) {
                            <div tappable (click)="setMember(member.membership)"
                                class="bg-blueGray-100 border-0 w-full cursor-pointer">
                                <p class="px-3 pb-3 text-sm text-primary-500">{{member.membership.name}}</p>
                            </div>
                            }
                        </div>
                    </div>
                    <div
                        class="h-6 text-red-500 text-xs {{ pageForm.get('requestedBy')?.invalid && (pageForm.get('requestedBy')?.dirty || pageForm.get('requestedBy')?.touched) ? 'visible' : 'invisible'}}">
                        <p *ngIf="pageForm.get('requestedBy')?.errors?.['required']">
                            Value is required
                        </p>
                        <p *ngIf="pageForm.get('requestedBy')?.errors?.['notFound']">
                            No matching members found
                        </p>
                        <p *ngIf="pageForm.get('requestedBy')?.errors?.['searchFailed']">
                            Search failed. Please try later
                        </p>
                    </div>
                </div>

                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Expiry Date *
                    </label>
                    <input type="date" name="expiry" formControlName="expiry" placeholder="dd/mm/yyyy" required
                        class="border-0 px-3 py-2 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                        [min]="today" [max]="moment().add(1,'year')">
                    <div
                        class="{{ pageForm.get('expiry')?.invalid && (pageForm.get('expiry')?.dirty || pageForm.get('expiry')?.touched) ? 'visible' : 'invisible'}} h-6 pt-1 text-red-500 text-xs">
                        <div *ngIf="pageForm.get('expiry')?.errors?.['required']">
                            Value is required
                        </div>
                    </div>
                </div>

            </div>
            <button type="submit" [disabled]="!pageForm.valid || working"
                class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 text-white font-bold text-sm uppercase rounded px-4 py-2">
                <div *ngIf="!working" class="inline-block">
                    <i class="fa fa-save mr-2 leading-relaxed"></i>Create
                </div>
                <div *ngIf="working" class="inline-block">
                    <app-loading-dots></app-loading-dots>
                </div>
            </button>
            }
        </form>
    </div>
</div>